module.exports = __webpack_public_path__ + "img/fm-Path 38 Copy@3x.886f2252.png";